import React, { PropsWithChildren, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Emojis, LocationCls, ValueCls } from 'constants/constants';
import { SqRoutes } from 'constants/Routes';
import { useAppSelector } from 'hooks/hooks';
import { getFbSqUser, getIsUserLoggedIn, getUserAuthState, UserAuthState } from 'slices/SqUserSlice';
import { Maybe } from 'types/App.types';
import { FbSqUser } from 'types/SqGame.types';
import { auth } from '../firebase/Firebase';

interface AuthContextType {
  signedIn: boolean;
  user: Maybe<FbSqUser>;
  isAuthenticating: boolean;
}

const AuthContext = React.createContext<AuthContextType>(null!);

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const userLoggedIn = useAppSelector(getIsUserLoggedIn);
  const currentUser = useAppSelector(getFbSqUser);
  const userAuthState = useAppSelector(getUserAuthState);

  const signedIn = auth.currentUser ? true : userLoggedIn;
  const isAuthenticating = auth.currentUser ? false : userAuthState === UserAuthState.Authenticating;
  const user = currentUser;

  useEffect(() => {
    const msg = `${Emojis.eyes} %c AuthProvider %c, loggedIn %c ${userLoggedIn} %c, %c ${userAuthState} %c`;
    console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');
  }, [userLoggedIn, userAuthState]);

  const value = { signedIn, user, isAuthenticating };

  return (
    <>
      <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    </>
  );
};

const useAuth = () => {
  return React.useContext(AuthContext);
};
type RequireAuthOwnProps = {
  className?: string;
};
type RequireAuthProps = PropsWithChildren<RequireAuthOwnProps>;
const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const { signedIn, isAuthenticating } = useAuth();
  const location = useLocation();
  if (!signedIn) {
    const msg = `${Emojis.eyes} %c RequireAuth %c, signedIn %c ${signedIn} %c, %c ${isAuthenticating} %c`;
    console.log(msg, LocationCls, '', ValueCls, '', ValueCls, '');
    // || !auth.user
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    // console.log(`Navigating from ${location.pathname} to /auth/login`);
    return <Navigate to={SqRoutes.Login} state={{ from: location }} replace />;
  }

  return children;
};

export { AuthContext, AuthProvider, useAuth as default, RequireAuth };
